export interface CmsApplianceDetailsModelSerialExpiredLink {
  title: string;
  body: string;
}
